import CenteredContainer from './CenteredContainer';

export default CenteredContainer;
